import { render, staticRenderFns } from "./playClassModal.vue?vue&type=template&id=32dd6ad7&scoped=true&"
import script from "./playClassModal.vue?vue&type=script&lang=ts&"
export * from "./playClassModal.vue?vue&type=script&lang=ts&"
import style0 from "./playClassModal.vue?vue&type=style&index=0&id=32dd6ad7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd6ad7",
  null
  
)

export default component.exports